import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ObserverEmitter, { EVENTS } from "../../../emitter/Observer";
import { imgsTopicSevenActvOne } from "../../../assets/activityes/topicSevenActivityOne";
import { CheckboxActvone } from "./CheckboxActvone";
import { completeOneTask } from "../../../store/slices/menu/tunks";
import { useNavigate } from "react-router-dom";
import { tasksId } from "../../../types/activityTasks";
import { PanelActivities } from "../../../components/common/PanelActivities";
import { ButtonPlay } from "../../../components/common/ButtonPlay";
import { ButtonHome } from "../../../components/common/ButtonHome";
import { useGetActivitiesBySubTopic } from "../../../hooks/useGetActivitiesBySubTopic";
import { DialogBarNew } from "../../../components/common/DialogBarNew";
import { HeaderRedPresentation } from "../../../components/common/HeaderRedPresentation";
import { BarStatusActivies } from "../../../components/common/BarStatusActivies";
import { ValidationResultModal } from "../../../components/common/ValidationResultModal";
import { audiosAssets } from "../../../assets/audio";
import { DialogActivities } from "../../../components/common/DialogActivities";
import { voicesTypeControl } from "../../../types/audioType";
import { ButtonReturn } from "../../../components/common/ButtonReturn";

const steps = {
	dialogInitial: 1,
	viewActivities: 100,
	dialogTwo: 2,
	dialogThree: 3,
	instructions: 4,
	dialogFour: 5,
	dialogFive: 6,
	dialogSix: 7,
	dialogSeven: 8,
	dialog8: 9,
	dialog9: 10,
	dialog10: 11,
	dialog11: 12,
	dialog12: 13,
	dialog13: 14,
	dialog14: 15,
	dialog15: 16,
	dialog16: 17,
	dialog17: 18,
	dialog18: 19,
	dialog19: 20,
	dialog20: 21,
	dialog21: 22,
};

export const SubtopicSevenActivityOne = () => {
	const { loaded, activitiesInformation } = useSelector((state) => state.menu);
	const dispatch = useDispatch();
	const navigator = useNavigate();
	const [uiToShow, setUiToShow] = useState(steps.dialogInitial);
	const [checkboxStates, setCheckboxStates] = useState(Array(4).fill(false));
	const { tasksList, points } = useGetActivitiesBySubTopic(activitiesInformation[tasksId.tema1.activities.subtema7], 1);


	useEffect(() => {
		if (loaded) {
			console.log("subtema 7 Activity One");
			ObserverEmitter.emit(EVENTS.subtopicSeven.initScene, 1);
			ObserverEmitter.emit(EVENTS.audiosEvents.pauseActive, true)
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioScene, audiosAssets.escenarios.onOxxoScene)
		}
	}, [loaded]);

	ObserverEmitter.on(EVENTS.audioInitByTopic, () => {
		ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T1.sub07.sub7_act1_a01)
	})

	const handleCheckboxChange = (index) => {
		const updatedStates = [...checkboxStates];
		updatedStates[index] = !updatedStates[index];
		setCheckboxStates(updatedStates);

		// Verificar si todos los checkboxes están seleccionados
		if (updatedStates.every((isChecked) => isChecked)) {
			setUiToShow(steps.dialog9);
		}
	};

	return (
		<>
			<>
				<ButtonPlay />
				<ButtonHome />
				{![1, -1].includes(uiToShow) && (
					<ButtonReturn callback={() => {
						ObserverEmitter.emit(EVENTS.subtopicSeven.initScene, 1);
						setUiToShow(1)
						setCheckboxStates(Array(4).fill(false))
					}} />
				)}
			</>
			{uiToShow === steps.dialogInitial && (
				<>
					<HeaderRedPresentation name="Actividad 1: Responsabilidades operativas." />
					<DialogBarNew
						titulo="Datti Andatti"
						dialog={'A continuación veremos lo que son tus "Responsabilidades Operativas".'}
						percentage={"10%"}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.characterAnimations.hiddenModel);
							setUiToShow(steps.viewActivities);
						}}
					></DialogBarNew>
				</>
			)}
			{steps.viewActivities === uiToShow && (
				<>
					<PanelActivities
						buttonText="¡Comenzar!"
						title="Subtema 6: Responsabilidades operativas."
						titleActivity="Actividades por realizar:"
						points={points}
						insigniaBackground={0}
						actionButton={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T1.sub07.sub7_act1_a02)
							ObserverEmitter.emit(EVENTS.characterAnimations.idle);
							setUiToShow(steps.dialogTwo);
						}}
						activities={tasksList}
					/>
				</>
			)}
			{uiToShow === steps.dialogTwo && (
				<>
					<HeaderRedPresentation name="Actividad 1: Responsabilidades operativas." />
					<DialogBarNew
						titulo="Datti Andatti"
						dialog={"Las responsabilidades son lo que se espera y el deber ser de cada una de las tiendas para su correcta ejecución."}
						percentage={"20%"}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T1.sub07.sub7_act1_a03)
							setUiToShow(steps.dialogThree);
						}}
					></DialogBarNew>
				</>

			)}
			{uiToShow === steps.dialogThree && (
				<>
					<HeaderRedPresentation name="Actividad 1: Responsabilidades operativas." />
					<DialogBarNew
						titulo="Datti Andatti"
						dialog={"Todo se registra en el Cuadernillo de Responsabilidades Operativas."}
						percentage={"30%"}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T1.sub07.sub7_act1_a04)
							setUiToShow(steps.instructions);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.instructions && (
				<>
					<HeaderRedPresentation name="Actividad 1: Responsabilidades operativas." />
					<DialogBarNew
						titulo="Datti Andatti"
						dialog={"Selecciona y marca con una paloma dentro del sistema las actividades realizadas el día de hoy."}
						percentage={"30%"}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T1.sub07.sub7_act1_a05)
							ObserverEmitter.emit(EVENTS.characterAnimations.hiddenModel);
							setUiToShow(steps.dialogFour);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.dialogFour && (
				<>
					<BarStatusActivies activities={tasksList} />
					<ContainerImagesTable img={imgsTopicSevenActvOne.screen1}></ContainerImagesTable>
					<DialogBarNew
						titulo="Datti Andatti"
						dialog={`Dentro de la tablet nuestra primera acción será seleccionar la opción Excelencia Operativa.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T1.sub07.sub7_act1_a06)
							setUiToShow(steps.dialogFive);
						}}
						percentage={"40%"}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.dialogFive && (
				<>
					<ContainerImagesTable img={imgsTopicSevenActvOne.screen2}></ContainerImagesTable>
					<DialogBarNew
						titulo="Datti Andatti"
						dialog={`Se abrirá un cuadro, en el selecciona “Cuadernillo de Responsabilidades”`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T1.sub07.sub7_act1_a07)
							setUiToShow(steps.dialogSix);
						}}
						percentage={"45%"}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.dialogSix && (
				<>
					<ContainerImagesTable img={imgsTopicSevenActvOne.screen3}></ContainerImagesTable>
					<DialogBarNew
						titulo="Datti Andatti"
						dialog={`Selecciona la opción de Checklist de Responsabilidad Operativa.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T1.sub07.sub7_act1_a08)
							setUiToShow(steps.dialogSeven);
						}}
						percentage={"50%"}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogSeven && (
				<>
					<div className="fixed z-30 bottom-0 h-[calc(100%-80px)] md:h-[calc(100%-85px)] w-full flex justify-center items-center ">
						<div className="w-[439px] md:w-[1100px] h-[241px] md:h-[605px] bg-white rounded-lg border-[12px] md:border-[32px] border-[#282828] ">
							<div className="w-full h-[98px] md:h-[244px]">
								<img src={imgsTopicSevenActvOne.screen4} className="w-full h-full object-contain" alt="" />
							</div>
							<div className="w-full h-[120px] md:h-[300px]  overflow-y-auto">
								<CheckboxActvone
									text={"Limpieza"}
									value={0}
									checkboxStates={checkboxStates}
									handleCheckboxChange={handleCheckboxChange}
								></CheckboxActvone>
								<CheckboxActvone
									text={"Exibición"}
									value={1}
									checkboxStates={checkboxStates}
									handleCheckboxChange={handleCheckboxChange}
								></CheckboxActvone>
								<CheckboxActvone
									text={"Etiqueteo"}
									value={2}
									checkboxStates={checkboxStates}
									handleCheckboxChange={handleCheckboxChange}
								></CheckboxActvone>
								<CheckboxActvone
									text={"Promociones"}
									value={3}
									checkboxStates={checkboxStates}
									handleCheckboxChange={handleCheckboxChange}
								></CheckboxActvone>
							</div>
						</div>
					</div>
					<DialogActivities percentage={"100%"} dialog="Es momento de que marques con una palomita las actividades que has realizado durante todo tu recorrido." />
				</>
			)}

			{uiToShow === steps.dialog9 && (
				<>
					<ValidationResultModal
						title="¡Bien hecho!"
						numberPoints={5}
						dialogModal="Es importante registrar tus actvidades y mantener actualizadas todas tus responsabilidades."
						buttonTxt="Continuar"
						isCorrect={true}
						action={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							dispatch(
								completeOneTask({
									idActivity: 1,
									pointsWin: 5,
									subtema: tasksId.tema1.activities.subtema7,
								})
							);
							navigator("/home1/tema1/subtema7/activityTwo");
						}}
					/>
				</>
			)}
		</>
	);
};


const ContainerImagesTable = ({ img = "", callback = () => { }, children }) => {
	return (
		<>
			<div className="fixed z-30 h-full w-full flex justify-center items-center">
				<div className="w-[433px] h-[238px] md:w-[880px] md:h-[484px]">
					<div className="h-full w-full">
						<img className="h-full w-full object-contain" src={img} alt="images" />
					</div>
				</div>
				{children}
			</div>
		</>
	)
}